/**
 * MACRO #31 mobile hotfix — wallet connector visibility (no dead buttons).
 *
 * Rules:
 *  - Hide the GENERIC `injected` fallback when no injected provider actually
 *    exists (mobile Safari/Chrome) so the menu never shows a dead "Injected"
 *    button. The official `metaMask()` connector provides the real MetaMask
 *    mobile path instead.
 *  - De-duplicate by wallet name so MetaMask never appears twice (the official
 *    `metaMask()` connector + an EIP-6963-discovered injected "MetaMask").
 *  - Desktop keeps real injected/other wallets (provider present) and the
 *    single MetaMask entry; MetaMask in-app browser keeps injected working.
 */
export interface MinimalConnector {
  id: string;
  name: string;
}

export function hasInjectedProvider(): boolean {
  return typeof window !== "undefined" && !!(window as { ethereum?: unknown }).ethereum;
}

export function visibleConnectors<T extends MinimalConnector>(
  connectors: readonly T[],
  injectedAvailable: boolean = hasInjectedProvider(),
): T[] {
  const seen = new Set<string>();
  const out: T[] = [];
  for (const c of connectors) {
    // drop the generic injected fallback when there is no real provider
    if (c.id === "injected" && !injectedAvailable) continue;
    const key = c.name.trim().toLowerCase();
    if (seen.has(key)) continue; // first wins (official metaMask() precedes discovered)
    seen.add(key);
    out.push(c);
  }
  return out;
}
